'use strict'
/**
 * Icons · 5 navegación inferior.
 * Doc maestro 2.6 / 7.2: "Solo iconos, sin labels. Today · Hub · Calendar · Dominios · Progress."
 * aurIA NO es nav · es FAB separado.
 */
import React from 'react'
import Icon from './_base'

// Today · sol + horizonte sutil · "hoy"
export const NavToday = (p) => (
  <Icon {...p}>
    <circle cx="12" cy="13" r="3.5" />
    <path d="M3 19h18" />
    <path d="M12 5v2.5" />
    <path d="M5 13H3.5" />
    <path d="M20.5 13H22" />
    <path d="M6.5 7.5l1 1" />
    <path d="M16.5 8.5l1-1" />
  </Icon>
)

// Hub · gauge · análisis de entreno
export const NavHub = (p) => (
  <Icon {...p}>
    <path d="M4 16a8 8 0 1 1 16 0" />
    <path d="M12 16l4-5" />
    <circle cx="12" cy="16" r="1" fill="currentColor" stroke="none" />
  </Icon>
)

// Calendar · calendario clásico clean
export const NavCalendar = (p) => (
  <Icon {...p}>
    <rect x="4" y="6" width="16" height="14" rx="2" />
    <line x1="4" y1="10" x2="20" y2="10" />
    <line x1="9" y1="4" x2="9" y2="8" />
    <line x1="15" y1="4" x2="15" y2="8" />
  </Icon>
)

// Dominios · prisma 8 facetas (refleja los 8 dominios)
export const NavDomains = (p) => (
  <Icon {...p}>
    <polygon points="12,3 18,7 18,15 12,19 6,15 6,7" />
    <line x1="12" y1="3" x2="12" y2="19" />
    <line x1="6" y1="7" x2="18" y2="15" />
    <line x1="6" y1="15" x2="18" y2="7" />
  </Icon>
)

// Nutrition · hoja/brote (dominio nutrición · sage) — orgánico, no un plato/cubierto
export const NavNutrition = (p) => (
  <Icon {...p}>
    <path d="M12 21 C12 14, 7 9, 4 8 C4 14, 8 20, 12 21 Z" />
    <path d="M12 21 C12 12, 16 6, 20 4 C20 12, 16 19, 12 21 Z" />
    <line x1="12" y1="21" x2="12" y2="11" />
  </Icon>
)

// Progress · gráfico de tendencia ascendente
export const NavProgress = (p) => (
  <Icon {...p}>
    <path d="M4 18l5-5 4 4 7-9" />
    <path d="M16 8h4v4" />
  </Icon>
)

export const NavIcons = {
  today:     NavToday,
  hub:       NavHub,
  calendar:  NavCalendar,
  nutricion: NavNutrition,
  domains:   NavDomains,
  progress:  NavProgress,
}
export default NavIcons
